import { mintEntityId } from "@repo/domain";
import { getDataStoreClient } from "../core/provider";
import type { ActivityDefinitionRow } from "../fhir/types";

export function mintExamIds(): Record<string, string> {
  const definitions = getDataStoreClient().getCollection<ActivityDefinitionRow, string>("activityDefinition");
  return Object.fromEntries(
    [...definitions.state.values()].flatMap((row) => (row.url ? [[row.url, mintEntityId()]] : [])),
  );
}
